<template>
  <div :class="{ box:true }">
    <div class="text">
      {{ data.text }}
    </div>
    <div :class="{ 'audio-button': true, playing, hideSpeaker }" @click="playButton" v-if="data.audioType">
      <font-awesome-icon icon="volume-up" class="icon"/>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import alert from '@/lib/alert';

export default {
  props: {
    data: Object,
    hideSpeaker: Boolean
  },
  name: 'Bot',
  data() {
    return {
      playing: false,
      nextOnce: false,
    }
  },
  methods: {
    ...mapActions('player', ['playerPlay', 'playerStop']),
    // ...mapActions('alerts', ['setError']),
    playButton() {
      if(this.playing) {
        this.stop();
      } else {
        if(this.playingState) {
          this.playerStop();
          this.play();
        } else {
          this.play();
        }
      }
    },
    play() {
      if(this.data.audioType == 'bot') {
        this.playing = true;
        this.playerPlay({ type: 'bot', payload: { text: this.data.text, voice: this.data.selectedVoice } }).then(() => {
          this.playing = false;
          if(!this.nextOnce) {
            this.$emit('nextAnswer');
            this.nextOnce = true;
          }
        }).catch(err => {
          this.playing = false;
          console.log(`Error: ${err}`); // Global Error!!!
          // this.setError(err);
          alert.showError(err);
        });
      } else if(this.data.audioType == 'micro'){
        this.playing = true;
        this.playerPlay({ type: 'micro', payload: this.data.audioData }).then(() => {
          this.playing = false;
          if(!this.nextOnce) {
            this.$emit('nextAnswer');
            this.nextOnce = true;
          }
        }).catch(err => {
          this.playing = false;
          console.log(`Error: ${err}`); // Global Error!!!
          // this.setError(err);
          alert.showError(err);
        });
      } else {
        if(!this.nextOnce) {
          this.nextOnce = true;
          setTimeout(() => {
            this.$emit('nextAnswer');
          }, 1500);
        }
      }
    },
    stop() {
      this.playerStop();
      this.playing = false;
    },
  },
  computed: {
    ...mapGetters('player', ['playingState']),
    ...mapGetters('recording', ['getCurrentBotAudioType'])
  },
  mounted() {
    if(this.playingState) {
      this.playerStop();
      this.play();
    } else {
      this.play();
    }
  }
}
</script>

<style lang="scss" scoped>
.box {
  width: 100%;
  min-height: 6rem;
  background-color: #0e9c8e;
  border-radius: 0.5rem;
  display: flex;
  animation: appear 1s 0.2s forwards;
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
  opacity: 0;
  z-index: 10;
  position: relative;
  padding-bottom: 1rem;
  padding-top: 1rem;
  @media (max-width: 1050px) {
    width: 90%;
  }
  @keyframes appear {
    0% {
      transform: translateX(-3rem);
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
  .text {
    flex: auto;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    padding-left: 1rem;
    padding-right: 1rem;
    font-size: 1.2rem;
    color: white;
    word-break: break-word;
  }
  .audio-button {
    background-color: rgb(222, 214, 226);
    width: 2.2rem;
    height: 2.2rem;
    border-radius: 50%;
    position: absolute;
    right: 0.5rem;
    bottom: 0.5rem;
    display: flex;
    justify-content: center;
    align-items: center;
    color: rgb(54, 57, 63);
    transition: 0.3s;
    cursor: pointer;
    font-size: 0.9rem;
    &:hover {
      background-color: rgb(210, 203, 214);
    }
  }
  
  .playing {
    color: rgb(50, 180, 25);
  }
  .hideSpeaker {
    animation: hide 1s forwards;
    @keyframes hide {
      0% {
        transform: scale(1);
      }
      100% {
        transform: scale(0);
      }
    }
  }
}
</style>